import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';
import { Subject } from 'rxjs';
import { QnSbnDataServiceService } from '../../../../services/qn-sbn-data-service.service';
import { CreateReminderComponent } from '../create-reminder.component';
import { CommonModule } from '@angular/common';
import { ReminderMessageTempleteComponent } from '../reminder-message-templete/reminder-message-templete.component';


@Component({
  selector: 'dl-reminder-message-templete-dialog',
  standalone: true,
  imports: [OneWebComponentsAngularModule, ReminderMessageTempleteComponent, CommonModule, CreateReminderComponent, FormsModule],
  templateUrl: './reminder-message-templete-dialog.component.html',
  styleUrl: './reminder-message-templete-dialog.component.scss'
})
export class ReminderMessageTempleteDialogComponent implements OnChanges {
  visible: boolean = false;
  public spinBool: boolean = false;


  public constructor(
    private _QnSbnDataService: QnSbnDataServiceService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  public templateColumn: any;
  public templateData: any[] = [];
  public newReminderTemplate: Subject<any> = new Subject<any>();
  public isAffBtnDisabled = true;
  public isNtBtnDisabled = false;
  public isNewFromTemplate = true;
  public selectedRow = [];
  public remindersData = [];
  public isBlank = false;
  public feedbackDueDate = new FormControl<Date | null>(null);
  public addMoreReminders: Subject<any> = new Subject<any>();
  public notificationData: any; // Store notification data for passing to create-reminder
  @Output() dialogClose = new EventEmitter<any>();
  @Output() closeDialog = new EventEmitter<{ data: { newColumnData: string[]; newTableData: any[] } }>();

  @Input() data: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      const incomingData = changes['data'].currentValue;
      this.templateColumn = incomingData.columnData;
      
      // Show template data from API
      this.templateData = incomingData.tableData || [];
      
      if (incomingData.feedbackDueDate) {
        this.feedbackDueDate.setValue(incomingData.feedbackDueDate);
      }
      
      // Store notificationData for passing to create-reminder
      if (incomingData.notificationData) {
        this.notificationData = incomingData.notificationData;
      }
      
      // Load existing reminders if they exist
      if (incomingData.existingReminders && Array.isArray(incomingData.existingReminders)) {
        this.remindersData = [...incomingData.existingReminders];
        this.addMoreReminders.next(this.remindersData);
      }
      
      setTimeout(() => {
        this.changeDetectorRef.detectChanges();
      }, 300);

    }
    if (this.templateData.length > 0) {
      this.spinBool = false;
    }
  }

  public ngOnInit(): void {

    this._QnSbnDataService.mappingData$.subscribe(observer => {

      if (!this._QnSbnDataService.isEmpty(observer['feedbackDueDate'])) {
        this.feedbackDueDate?.setValue(new Date(observer['feedbackDueDate']['feedbackDueDate']));
      }
      if (!this._QnSbnDataService.isEmpty(observer['notificationReminders'])) {
        this.remindersData = observer['notificationReminders']['remindersData'];
        this.addMoreReminders.next(this.remindersData);
        this.changeDetectorRef.detectChanges();
      }
    })
  }

  feedbackOptionAdded(event: { isOptAdded: boolean }): void {
    this.isAffBtnDisabled = event.isOptAdded;
    this.isNtBtnDisabled = !event.isOptAdded;
  }


  public getSelectedRowInTemplate(rows: any): void {
    this.selectedRow = Array.isArray(rows.messageSelected)
      ? rows.messageSelected[0] ?? null
      : rows.messageSelected;

    const isSelected = !!this.selectedRow;
    this.isAffBtnDisabled = !isSelected;
    this.isNtBtnDisabled = isSelected;
  }


  public addTemplateToForm(): void {
    const selected = Array.isArray(this.selectedRow) ? this.selectedRow[0] : this.selectedRow;

    const newData = {
      newColumnData: ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'],
      newTableData: [selected]
    };

    this.closeDialog.emit({ data: newData });

    this.changeDetectorRef.detectChanges();

    this._QnSbnDataService.getMappedQnsbnData({
      reminderSubjectName: selected?.templateDetails?.templateSubject,
      reminderAttachmentRTEText: selected?.templateDetails?.templateBody,
      templateId: selected?.templateId || ""
    }, "reminderAttachment");


    const reminderData = {
      reminderSubject: selected?.templateDetails?.templateSubject || '',
      reminderMessage: selected?.templateDetails?.templateBody || '',
      reminderSendMode: '',
      reminderDate: ''
    };



    this.addReminderMessage(false, reminderData);
    setTimeout(() => {
      this.visible = true;
    }, 0);
  }

  public addReminderMessage(blank: boolean, reminderData?: any): void {
    this.data = {
      feedbackDueDate: this.feedbackDueDate,
      isEdit: false,
      isBlank: blank,
      notificationData: this.notificationData, // Pass notificationData to create-reminder
      reminderData: reminderData ?? {
        reminderSubject: '',
        reminderMessage: '',
        reminderSendMode: '',
        reminderDate: ''
      }
    };
    

    setTimeout(() => {
      this.visible = true;
      this.changeDetectorRef.detectChanges();
    }, 0);
  }

  public handleReminderClose(result: any): void {

    this.visible = false;

    if (!result?.data) {
      this.dialogClose.emit(null);
      return;
    }
    const mappedData = result.data.map(item => ({
      reminderDate: item.reminderDate || '',
      reminderSubject: item.reminderSubject || '',
      reminderMessage: item.reminderMessage || '',
      reminderSendMode: item.reminderSendMode ?? '0',
      reminderActionIcons: true,
      templateDetails: {
        templateSubject: item.reminderSubject || '',
        templateBody: item.reminderMessage || '',
      }
    }));


    this.remindersData = [...this.remindersData, ...mappedData];
    if (result.addToTemplate) {
      this.templateData = [...this.templateData, ...mappedData];
    } else {
    }



    this.changeDetectorRef.detectChanges();

    this.addMoreReminders.next(this.remindersData);
    this.addProduct(this.feedbackDueDate.value, this.remindersData);
    this.changeDetectorRef.detectChanges();
    this.dialogClose.emit({ data: mappedData });
  }


  public addProduct(newDate, reminderData) {
    this._QnSbnDataService.getMappedQnsbnData({
      "feedbackDueDate": newDate
    }, "FeedbackDueDate");
    this._QnSbnDataService.getMappedQnsbnData({
      "remindersData": reminderData
    }, "NotificationReminders");
  }

  ngOnDestroy(): void {
    this.addProduct(this.feedbackDueDate.value, this.remindersData);
  }

  onCancel() {
    this.dialogClose.emit(null);
  }
}


